import { render, staticRenderFns } from "./ClauseUpdate.vue?vue&type=template&id=62936326"
import script from "./ClauseUpdate.vue?vue&type=script&lang=js"
export * from "./ClauseUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports